import { RenderersUIType } from "@home-health-notify/domain";
import {
  and,
  ControlProps,
  isDescriptionHidden,
  RankedTester,
  rankWith,
  schemaTypeIs,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { Box, FormHelperText } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { merge } from "lodash";

const TimePickerRenderer = ({
  path,
  data,
  handleChange,
  uischema,
  errors,
  enabled,
  visible,
  description,
  config,
}: ControlProps) => {
  const hasError = Boolean(errors?.length);
  const { label, options } = uischema;
  const { timeFormat, minTime, maxTime } = options || {};
  const timePickerLabel = typeof label === "string" ? label : "Time";
  const [selectedTime, setSelectedTime] = useState<Dayjs | null>(
    data ? dayjs(data, timeFormat) : null,
  );

  const handleTimeChange = (newValue: Dayjs | null) => {
    if (newValue) {
      setSelectedTime(newValue);
      handleChange(path, newValue.format("HH:mm:ss"));
    }
  };

  const appliedUiSchemaOptions = merge({}, config, uischema.options);

  const isValid = !hasError;

  const showDescription = !isDescriptionHidden(
    visible,
    description,
    false,
    appliedUiSchemaOptions.showUnfocusedDescription,
  );

  const firstFormHelperText = showDescription
    ? description
    : !isValid
      ? errors
      : null;

  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          disabled={!enabled}
          label={timePickerLabel}
          value={selectedTime}
          format={"hh:mm A"}
          minTime={minTime}
          maxTime={maxTime}
          onChange={handleTimeChange}
          slotProps={{
            textField: {
              fullWidth: true,
              error: hasError,
              helperText: hasError ? errors : "",
            },
          }}
        />
        <FormHelperText error={!isValid && !showDescription}>
          {firstFormHelperText}
        </FormHelperText>
      </LocalizationProvider>
    </Box>
  );
};

export const timePickerTester: RankedTester = rankWith(
  5,
  and(uiTypeIs(RenderersUIType.TimePicker), schemaTypeIs("string")),
);

export default withJsonFormsControlProps(TimePickerRenderer);
